import { useQuery } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { courseFinancesApi } from "./courseFinancesApi";

export const useCourseFinancesByCategory = (courseId: string | number) => {
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_FINANCES_BY_CATEGORIES(courseId),
    queryFn: () => courseFinancesApi.fetchByCategories(courseId),
  });

  return { loading: isLoading, data: data?.data };
};
